import { FC } from 'react';
import { CellContext } from '@tanstack/react-table';
import {
  CompaniesIcon,
  InvalidCompanyValueIcon,
  SingleUserIcon,
  SingleUserWarningIcon,
  UserDeleteIcon,
  UserDisabledIcon
} from '../../../../icons';
import { IconProps } from '../../../../icons/templates/icon';
import { TooltipComponent } from '../../../atomic/feedback';
import { useTranslation } from 'react-i18next';
import {
  AssignmentTypeEnum,
  CompanyCustomBenefitAssignmentEmployee
} from '@pxtra-client-lib-legacy/gen';
import { getAssignmentType } from '../utils';

type StrategyOption = 'global' | AssignmentTypeEnum;

const iconMap: Record<StrategyOption, FC<IconProps>> = {
  individual: SingleUserIcon,
  global: CompaniesIcon,
  deactivated_by_CM: UserDeleteIcon,
  invalid_individual_assignment: SingleUserWarningIcon,
  invalid_global_assignment: InvalidCompanyValueIcon,
  assignment_forbidden: UserDisabledIcon
};

export const AssignmentTypeCell = ({
  row
}: CellContext<CompanyCustomBenefitAssignmentEmployee, unknown>) => {
  const { t } = useTranslation();
  const assignmentType = getAssignmentType(row.original);
  const IconComponent = iconMap[assignmentType as StrategyOption];

  if (!IconComponent) return null;

  return (
    <TooltipComponent arrow placement="top" title={t(`custom:${assignmentType}`)}>
      <div className="flex justify-center">
        <IconComponent
          color={
            ['invalid_global_assignment', 'invalid_individual_assignment'].includes(assignmentType)
              ? 'error.main'
              : 'primary.main'
          }
        />
      </div>
    </TooltipComponent>
  );
};
